[
  {
    "id": "TB-M7P-001",
    "module": "Taalbegrip",
    "difficulty": 204,
    "question": "Lees de tekst:\n\n\"Steeds meer mensen werken vanuit huis. Enerzijds bespaart dit reistijd en is het goed voor het milieu. Anderzijds missen werknemers het contact met collega's. Bedrijven zoeken naar een balans tussen thuiswerken en op kantoor werken.\"\n\nWat is de tekststructuur?",
    "options": ["Voor- en nadelen afwegen", "Een probleem en oplossing beschrijven", "Een tijdsvolgorde vertellen", "Een verhaal vertellen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "tekststructuur",
    "familyId": "TB-STRUCTUUR-THUISWERK",
    "explanation": "'Enerzijds... anderzijds' presenteert twee kanten: voordelen (reistijd, milieu) en nadelen (gemis contact).",
    "distractorExplanations": {
      "1": "Er wordt geen specifiek probleem opgelost.",
      "2": "Er is geen tijdsvolgorde.",
      "3": "Het is geen verhaal maar een betoog."
    }
  },
  {
    "id": "TB-M7P-002",
    "module": "Taalbegrip",
    "difficulty": 204,
    "question": "Lees de tekst:\n\n\"De Grote Oceaan is de grootste en diepste oceaan ter wereld. Op het diepste punt, de Marianentrog, is het water bijna 11 kilometer diep. Dat is dieper dan de Mount Everest hoog is!\"\n\nWaarom noemt de schrijver de Mount Everest?",
    "options": ["Om de diepte van de oceaan begrijpelijk te maken door vergelijking", "Omdat de Mount Everest in de oceaan staat", "Omdat de Mount Everest even diep is", "Om te laten zien dat bergen belangrijk zijn"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "doel_schrijver",
    "familyId": "TB-OCEAAN-EVEREST",
    "explanation": "De schrijver vergelijkt de diepte met iets bekends (de Everest) om het voorstelbaar te maken. 11 km is abstract; 'dieper dan de Everest hoog is' is concreet.",
    "distractorExplanations": {
      "1": "De Everest staat niet in de oceaan.",
      "2": "De Everest is hoog, niet diep.",
      "3": "Het gaat niet over het belang van bergen."
    }
  },
  {
    "id": "TB-M7P-003",
    "module": "Taalbegrip",
    "difficulty": 204,
    "question": "Tik op het stuk tekst waar 'dat' naar verwijst in de tweede zin.",
    "options": ["spinnen insecten zijn"],
    "correctAnswer": 0,
    "questionType": "text_highlight",
    "interactiveConfig": {
      "segments": [
        { "text": "Veel mensen denken dat ", "id": "s1", "isTappable": false },
        { "text": "spinnen insecten zijn", "id": "s2", "isCorrect": true },
        { "text": ". ", "id": "s3", "isTappable": false },
        { "text": "Dat", "id": "s4", "isHighlighted": true, "isTappable": false },
        { "text": " klopt niet. ", "id": "s5", "isTappable": false },
        { "text": "Insecten hebben 6 poten", "id": "s6" },
        { "text": ", ", "id": "s7", "isTappable": false },
        { "text": "spinnen hebben er 8", "id": "s8" },
        { "text": ". Bovendien hebben insecten vleugels en spinnen niet.", "id": "s9", "isTappable": false }
      ],
      "feedbackMap": {
        "s2": "Goed! 'Dat klopt niet' verwijst naar de bewering dat spinnen insecten zijn.",
        "s6": "Dit wordt pas in de derde zin uitgelegd als verschil.",
        "s8": "Dit is een feit over spinnen, niet waar 'dat' naar verwijst."
      }
    },
    "skill": "verbanden",
    "subSkill": "verwijswoorden",
    "familyId": "TB-VERWIJS-SPINNEN",
    "explanation": "'Dat klopt niet' verwijst naar de bewering in de eerste zin: dat spinnen insecten zijn.",
    "distractorExplanations": {
      "5": "Dit wordt pas in de derde zin uitgelegd.",
      "7": "Dit is een feit over spinnen, niet waar 'dat' naar verwijst."
    }
  },
  {
    "id": "TB-M7P-004",
    "module": "Taalbegrip",
    "difficulty": 204,
    "question": "Wat betekent het woord 'arrogant' in de zin: 'De nieuwe leerling gedroeg zich arrogant.'",
    "options": ["Verwaand, alsof je beter bent dan anderen", "Verlegen en stil", "Heel aardig", "Heel grappig"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-WOORD-ARROGANT",
    "explanation": "'Arrogant' betekent verwaand of uit de hoogte. Je doet alsof je beter bent dan anderen.",
    "distractorExplanations": {
      "1": "Verlegen is juist het tegenovergestelde van arrogant.",
      "2": "Aardig is het tegenovergestelde.",
      "3": "Grappig heeft een andere betekenis."
    }
  },
  {
    "id": "TB-M7P-005",
    "module": "Taalbegrip",
    "difficulty": 204,
    "question": "Lees de advertentie:\n\n\"NIEUW! SuperClean Allesreiniger — maakt alles schoon in één keer! Geen schrobben meer nodig. Nu met 30% korting. Op=Op!\"\n\nWat voor soort tekst is dit?",
    "options": ["Een wervende tekst (reclame)", "Een informatieve tekst", "Een instructietekst", "Een nieuwsbericht"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "tekstsoort",
    "familyId": "TB-TEKSTSOORT-RECLAME",
    "explanation": "De tekst wil je overtuigen om iets te kopen. Signalen: 'NIEUW!', overdrijving ('alles in één keer'), korting, 'Op=Op!'.",
    "distractorExplanations": {
      "1": "De tekst informeert niet objectief maar wil verkopen.",
      "2": "Er wordt niet uitgelegd hoe je iets moet doen.",
      "3": "Het is geen nieuwsbericht maar reclame."
    }
  },
  {
    "id": "TB-M7P-006",
    "module": "Taalbegrip",
    "difficulty": 204,
    "question": "Lees de tekst:\n\n\"Koraal ziet eruit als een plant, maar het is eigenlijk een dier. Koraalriffen worden ook wel 'de regenwouden van de zee' genoemd. Net als regenwouden herbergen ze een enorme verscheidenheid aan leven.\"\n\nWaarom worden koraalriffen 'de regenwouden van de zee' genoemd?",
    "options": ["Omdat ze net als regenwouden heel veel verschillende soorten leven bevatten", "Omdat ze op bomen lijken", "Omdat het er regent", "Omdat ze groen zijn"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "conclusie_trekken",
    "familyId": "TB-KORAAL-REGENWOUD",
    "explanation": "De tekst legt het uit: 'Net als regenwouden herbergen ze een enorme verscheidenheid aan leven.' De vergelijking gaat over biodiversiteit.",
    "distractorExplanations": {
      "1": "De vergelijking gaat over biodiversiteit, niet over uiterlijk.",
      "2": "Regen wordt niet als reden genoemd.",
      "3": "De kleur wordt niet als reden genoemd."
    }
  },
  {
    "id": "TB-M7P-007",
    "module": "Taalbegrip",
    "difficulty": 204,
    "question": "Welk signaalwoord past het best?\n\n\"De leerlingen hadden hard gestudeerd. ... haalden ze allemaal een voldoende.\"",
    "options": ["Daardoor", "Desondanks", "Hoewel", "Maar"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verbanden",
    "subSkill": "signaalwoorden",
    "familyId": "TB-SIGNAAL-DAARDOOR",
    "explanation": "'Daardoor' geeft oorzaak-gevolg aan: hard studeren (oorzaak) → voldoende halen (gevolg).",
    "distractorExplanations": {
      "1": "'Desondanks' zou een tegenstelling zijn (ondanks hard studeren toch zakken).",
      "2": "'Hoewel' geeft ook een tegenstelling aan.",
      "3": "'Maar' geeft een tegenstelling aan."
    }
  },
  {
    "id": "TB-M7P-008",
    "module": "Taalbegrip",
    "difficulty": 204,
    "question": "Tik op het stuk tekst waar 'sindsdien' naar verwijst.",
    "options": ["in 1997"],
    "correctAnswer": 0,
    "questionType": "text_highlight",
    "interactiveConfig": {
      "segments": [
        { "text": "De Elfstedentocht is een beroemde schaatswedstrijd over 200 km. Hij wordt alleen gehouden als ", "id": "s1", "isTappable": false },
        { "text": "het ijs dik genoeg is", "id": "s2" },
        { "text": ". De laatste tocht was ", "id": "s3", "isTappable": false },
        { "text": "in 1997", "id": "s4", "isCorrect": true },
        { "text": ". ", "id": "s5", "isTappable": false },
        { "text": "Sindsdien", "id": "s6", "isHighlighted": true, "isTappable": false },
        { "text": " is het niet meer koud genoeg geweest.", "id": "s7", "isTappable": false }
      ],
      "feedbackMap": {
        "s2": "Het ijs is een voorwaarde, niet het tijdstip waar 'sindsdien' naar verwijst.",
        "s4": "Goed! 'Sindsdien' verwijst naar 1997, het jaar van de laatste tocht."
      }
    },
    "skill": "verbanden",
    "subSkill": "verwijswoorden",
    "familyId": "TB-VERWIJS-ELFSTEDEN",
    "explanation": "'Sindsdien' verwijst naar het laatstgenoemde tijdstip: 1997, het jaar van de laatste tocht.",
    "distractorExplanations": {
      "1": "Het ijs is een voorwaarde, niet het tijdstip."
    }
  },
  {
    "id": "TB-M7P-009",
    "module": "Taalbegrip",
    "difficulty": 204,
    "question": "Wat betekent het woord 'herbergen' in de zin: 'Koraalriffen herbergen een enorme verscheidenheid aan leven.'",
    "options": ["Onderdak bieden aan, bevatten", "Vernietigen", "Bouwen", "Bestuderen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-WOORD-HERBERGEN",
    "explanation": "'Herbergen' betekent onderdak bieden, een thuis geven. Een herberg is een plek waar je kunt overnachten.",
    "distractorExplanations": {
      "1": "Vernietigen is het tegenovergestelde.",
      "2": "Bouwen is iets anders.",
      "3": "Bestuderen is iets anders."
    }
  },
  {
    "id": "TB-M7P-010",
    "module": "Taalbegrip",
    "difficulty": 204,
    "question": "Lees de tekst:\n\n\"Volgens een enquête vindt 70% van de Nederlanders dat er meer fietspaden moeten komen. Slechts 15% is het daar niet mee eens. De rest heeft geen mening.\"\n\nWelke conclusie kun je trekken?",
    "options": ["Een grote meerderheid wil meer fietspaden", "Niemand wil meer fietspaden", "Iedereen fietst in Nederland", "De enquête is onbetrouwbaar"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "conclusie_trekken",
    "familyId": "TB-CONCLUSIE-FIETSPADEN",
    "explanation": "70% is een grote meerderheid. Slechts 15% is tegen. De conclusie is dat de meeste mensen meer fietspaden willen.",
    "distractorExplanations": {
      "1": "70% wil juist wel meer fietspaden.",
      "2": "De tekst zegt niet dat iedereen fietst.",
      "3": "Er is geen reden om de enquête onbetrouwbaar te noemen."
    }
  }
]